import React from "react";

/**
 * Scalloped / wavy SVG divider placed at the bottom of hero banners.
 * Fills with the color of the section below.
 */
export default function WavyDivider({ fill = "#FFFCF9", className = "" }) {
  return (
    <div
      className={`absolute bottom-0 left-0 right-0 overflow-hidden leading-none ${className}`}
      aria-hidden="true"
      data-testid="wavy-divider"
    >
      <svg
        viewBox="0 0 1440 110"
        preserveAspectRatio="none"
        className="block w-full h-[60px] md:h-[90px] lg:h-[110px]"
      >
        <path
          d="M0,40 C120,90 240,90 360,55 C480,20 600,20 720,55 C840,90 960,90 1080,55 C1200,20 1320,20 1440,55 L1440,110 L0,110 Z"
          fill={fill}
        />
      </svg>
    </div>
  );
}
